import React from 'react'
import './cookies.css'
function Cookies() {
  return (
    <>
    <div className="cookies">
    <h1>Cookies Policy for Diwise</h1>

    <p>At DIwise, we value the privacy and security of our users. This Cookies Policy explains how we use cookies and similar technologies on our website, www.diwise.in ("Website"). By using our Website, you consent to the use of cookies and similar technologies in accordance with this policy.
</p>

 
   

    <h2>What are cookies?</h2>

    <p>Cookies are small data files that are placed on your device when you visit a website. They are widely used to make websites work or to work more efficiently, as well as to provide information to the website owners.</p>

    <h2>How we use cookies?</h2>

    <p>We use cookies on our Website for a variety of purposes, including but not limited to:</p>

    <h2>How we use your information</h2>

    <p>We use the information we collect in various ways, including to:</p>

    <ul className='cookies_ul'>
        <li>Analyzing how our Website is used and improving its performance</li>
        <li>Personalizing your experience on our Website</li>
        <li>Remembering your preferences and settings</li>
        <li>Delivering relevant advertising to you</li>
        <li>Providing social media features</li>
        
    </ul>

    <h2>Types of cookies we use:</h2>

    <p>There are different types of cookies that we use on our Website. These include:</p>

    <h2>Essential cookies:</h2>

    <p>These cookies are necessary for our Website to function properly and cannot be switched off in our systems. They are usually only set in response to actions made by you, such as setting your privacy preferences, logging in, or filling in forms.</p>


   <h2>Analytical/performance cookies:</h2>
<p>These cookies allow us to count visits and traffic sources, so we can measure and improve the performance of our Website. They help us know which pages are the most and least popular and see how visitors move around the Website.</p>

    <h2>Functionality cookies:</h2>

    <p>These cookies enable the Website to provide enhanced functionality and personalization. They may be set by us or by third-party providers whose services we have added to our pages. Advertising/targeting cookies: These cookies are used to deliver advertisements more relevant to you and your interests. They may be used to deliver targeted advertising or to limit the number of times you see an advertisement.

</p>
   

    <h2>Advertising/targeting cookies:</h2>

    <p>These cookies are used to deliver advertisements more relevant to you and your interests. They may be used to deliver targeted advertising or to limit the number of times you see an advertisement.</p>


    <h2>Third Party Cookies:</h2>

    <p>We may also use third-party cookies on our Website. These cookies are placed by third-party service providers who perform services on our behalf, such as analytics and advertising.</p>
       

    <h2>Managing cookies</h2>

    <p>You can manage cookies through the settings on your web browser. However, please note that if you block or delete cookies, some features of our Website may not function properly.</p>
   

    <h2>Changes to this policy:</h2>

    <p>We may update this Cookies Policy from time to time. Any changes we make to our policy will be posted on this page.</p>

   <h2>Contact Us:</h2>
   <p>If you have any questions about this Cookies Policy, you can contact us at info@diwise.in</p>

   
</div>
</>
  )
}

export default Cookies